
import { use, registerTheme } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { UniversalTransition } from 'echarts/features'
import { PieChart } from 'echarts/charts'
import {
  // TitleComponent,
  DatasetComponent,
  TooltipComponent,
  LegendComponent
  // GridComponent
} from 'echarts/components'

import VChart from 'vue-echarts'

// custom theme
import themeEnerdata from '@/assets/json/echarts_themes/enerdata.project.json'

use([
  CanvasRenderer,
  UniversalTransition,
  PieChart,
  // TitleComponent,
  DatasetComponent,
  TooltipComponent,
  LegendComponent
  // GridComponent
])

// registering custom theme
registerTheme('enerdata-theme', themeEnerdata.theme)

export default {
  name: 'EnerEchartsPie',
  components: {
    VChart
  },
  props: {
    option: {
      type: Object,
      default () {
        return {}
      }
    },
    initOptions: {
      type: Object,
      default () {
        return {}
      }
    },
    updateOptions: {
      type: Object,
      default () {
        return {}
      }
    },
    group: {
      type: String,
      default: null,
      required: false
    },
    highlight: {
      type: String,
      default: null,
      required: false
    }
  },
  data () {
    return {}
  },
  methods: {
    handleRendered () {
      if (this.$refs.chart !== undefined) {
        this.$refs.chart.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          name: this.highlight
        })
      }
    }
  }
}
